export const messages = {
  'zh': {
    i18n: {
      breadcrumb: '国际化产品',
      tips: '通过切换语言按钮，来改变当前内容的语言。',
      btn: '切换英文',
      title1: '常用用法',
      p1: '要是你把你的秘密告诉了风，那就别怪风把它带给树。',
      p2: '没有什么比信念更能支撑我们度过艰难的时光了。',
      p3: '只要能把自己的事做好，并让自己快乐，你就领先于大多数人了。',
      title2: '组件插值',
      info: 'Element组件需要国际化，请参考 {action}。',
      value: '文档',

      site_title: '碳智 — 碳排放政策信息服务平台',
      welcome: '欢迎',
      login: '登录',
      captcha: '验证码',
      please_captcha: '请输入验证码',
      logout: '注销',
      account: '账号',
      password: '密码',
      forgot_password: '忘记密码 ?',
      stay_logged_in: '保持登录状态',
      sign_up_account: '注册账户',
      please_input_keywords: '请在这里输入检索词',
      please_select_agency: '请选择发布机构',
      please_select_area: '请选择区域范围',
      please_select_industry: '请选择行业类别',
      start_month: '开始月份',
      end_month: '结束月份',
      hot_spots: '热词导航',
      hot_words: '热点热词',
      issue_agency: '发布机构',
      union_issue_agency: '联合发布机构',
      issue_area: '区域范围',
      policy: '政策',
      key_words: '关键词：',
      date_format: 'yyyy年MM月dd日',
      analysis_report: '分析报告',
      management_practice: '企业碳管理与实践',
      more: '更多',
      report_name_1: '汽车行业碳中和两会提案解读与速览',
      report_name_2: '欧盟推进碳边境调节机制进程，钢铁和铝行业将受重大影响',
      report_name_3: '2019氢燃料电池汽车产业报告',
      report_date_1: '2022年3月10日',
      report_date_2: '2022年3月29日',
      report_date_3: '2019年11月1日',
      contacts_mode: '联系方式',
      register_telephone: '联系电话',
      register_email: '联系邮箱',
      contacts_mode_register: '联系方式',
      address_name: '地　　址',
      filing_name: '备案信息',
      filing_site: '京ICP备2022018000号-3',
      filing_public: '京公网安备 11010802039515号',
      contacts_telephone: 'Tel: 010-62132901',
      contacts_email: 'Email: carbon@goldenbeechina.com',
      company_name: '责扬天下（北京）管理顾问有限公司',
      address: '北京市海淀区中关村南大街12号百欣科技楼4001室',
      company: '公司',
      contacts_name: '联系人姓名',
      company_oem: '邀请人(OEM)',
      publish_date: '发布日期',
      subject_category: '主 &nbsp;题 &nbsp;分 &nbsp;类',
      subject_title: '标　　题',
    }
  },
  'en': {
    i18n: {
      breadcrumb: 'International Products',
      tips: 'Click on the button to change the current language. ',
      btn: 'Switch Chinese',
      title1: 'Common usage',
      p1: "If you reveal your secrets to the wind you should not blame the wind for  revealing them to the trees.",
      p2: "Nothing can help us endure dark times better than our faith. ",
      p3: "If you can do what you do best and be happy, you're further along in life  than most people.",
      title2: 'Component interpolation',
      info: 'The default language of Element is Chinese. If you wish to use another language, please refer to the {action}.',
      value: 'documentation',

      site_title: 'CARBON - Information Service Platform on Carbon Emission Policy',
      welcome: 'Welcome',
      login: 'Sign In',
      captcha: 'Captcha code',
      please_captcha: 'Please input captcha code',
      logout: 'Logout',
      account: 'Account',
      password: 'Password',
      forgot_password: 'Forgot password ?',
      stay_logged_in: 'Stay logged in',
      sign_up_account: 'Register Account',
      please_input_keywords: 'Please enter the search term here',
      please_select_agency: 'Select ISSUING AGENCY',
      please_select_area: 'Select REGIONAL SCOPE',
      please_select_industry: 'Select INDUSTRY CATEGORY',
      start_month: 'Start month',
      end_month: 'End month',
      hot_spots: 'HOTSPOTS',
      hot_words: 'HOT WORDS',
      issue_agency: 'ISSUING AGENCY',
      union_issue_agency: 'UNION ISSUING AGENCY',
      issue_area: 'REGIONAL SCOPE',
      policy: 'Policies',
      key_words: 'Key words：',
      date_format: 'MM/dd/yyyy',
      analysis_report: 'Analysis Report',
      management_practice: 'Enterprise Carbon Management And Practice',
      more: 'More',
      report_name_1: 'Quick View of the Carbon Neutralization Proposals in the Automotive Industry at the Two Sessions',
      report_name_2: 'EU CBRM Accelerating, the Steel and Aluminum Industries will be Greatly Affected',
      report_name_3: '2019 Hydrogen Fuel Cell Vehicle Industry Report',
      report_date_1: '03/10/2022',
      report_date_2: '03/29/2022',
      report_date_3: '11/01/2019',
      contacts_mode: 'Contacts',
      register_telephone: 'Contacts telephone',
      register_email: 'Contacts email',
      contacts_mode_register: 'Contact details',
      address_name: 'Address',
      filing_name: 'Filing Information',
      filing_site: '京ICP备2022018000号-3',
      filing_public: '京公网安备 11010802039515号',
      contacts_telephone: 'Tel: 010-62132901',
      contacts_email: 'Email: carbon@goldenbeechina.com',
      company_name: 'GoldenBee (Beijing) Management Consulting Co., Ltd. ',
      address: 'Room 4001, Baixin Science and Technology Building, No. 12, Zhongguancun South Street, Haidian District, Beijing',
      company: 'Company',
      contacts_name: 'Contact person name',
      company_oem: 'Company(OEM)',
      publish_date: 'Publish Date',
      subject_category: 'Subject Category',
      subject_title: 'Title',
    }
  }
}
